import { action, createReducer } from 'shared/utils/redux'
const reducerHandler = createReducer()
//请求方式
export const getHomeConfigs = action({//获取banner，产品广告图配置
  type: 'home.getHomeConfigs',
  action: (http, dispatch, getState) => {
    return http.get('/cms-web-api/config/mutil',{
      params: {
        names:[
          'banner',//首页轮播图
          'homeNews',//首页新闻中心带图片新闻
        ]
      }
    })//获得广告位信息
  },
  handler: (state, result) => {
    return {
      ...state,
      banner:result && result.data.banner,//轮播图
      homeNews:result && result.data.homeNews,//首页新闻中心带图片新闻
    }}
}, reducerHandler)




export const getNews = action({
  type: 'aboutUs.getNewsList',
  action: (http) => {
    return http.get('/cms-web-api/cms/content/list/ztx/news')
  },
  handler: (state, result) => {
    return {
      ...state,
      news: result.data.items
    }
  }
}, reducerHandler)


export const reducer = reducerHandler({})



// WEBPACK FOOTER //
// ./modules/home/redux.js